<!--Logged out header-->
@if (!isUserLoggedIn || (isUserLoggedIn && (!userInfo?.webEnabled))) {
  <!---Logged out header UK-->
  @if ((node$ | async); as navNode) {
    <div>
      @if (navNode.title == 'For UK Healthcare Professionals Only' || navNode.title == 'For UK Patients and members of the public') {
        <div class="header d-none d-sm-none d-md-block d-lg-block" [ngClass]="{'foruk_header': Ukclass}">
          <div class="container container-top-header ">
            <div class="row">
              <div class="col-sm-4 leftsectionheader">
                <div class="for-healthcare-profe healthcare-US">
                  <span>{{ navNode.title }}</span>
                </div>
              </div>
              <div class="col-sm-8 rightsectionheader">
                <div class="header-nav" [ngClass]="currentSite==='seqirusb2b-uk' && publicpage?'publicpageenable':''">
                  @for (nav of ukNavigation; track nav) {
                    <ul class="login-links marginBottom">
                      @if (isUserLoggedIn && !userInfo?.webEnabled) {
                      <li class="dropdown">
                        <a
                          [routerLink]="(isUserLoggedIn && !userInfo?.webEnabled && nav.title === 'Log in') ? '/logout' : nav.url"
                          (click)="reloadAfterLogout()" class="droppreb"
                          >
                          {{ (isUserLoggedIn && !userInfo?.webEnabled && nav.title === 'Log in') ? 'Log out' : nav.title }}
                          @if (nav.title === 'Log in') {
                            <span style="margin-left: 5px;">
                              <img alt="Log in icon" style="width: 28px;" src="/assets/images/login_icon.png">
                            </span>
                          }
                        </a>
                      </li>
                    }
                    </ul>
                  }
                </div>
              </div>
            </div>
          </div>
          <div style="clear:both"></div>
          <div class="whiteBguk">
            <div class="row">
              @if (ukSiteLogos$ | async; as ukLogos) {
                <div class="col-md-4 uk_Logout_SiteLogo">
                  @if(publicpage){
                  @for (logo of ukLogos; track logo) {
                   <span>
                      <img [src]="getImage(logo)" [alt]="logo.altText || 'UK Site Logo'" [ngClass]="logo.altText === 'flu360 color logo' ? 'flu360_Logo' : 'seqirus_Logo'"> 
                   </span>
                  }
                  
                }@else{
                  @for (logo of ukLogos; track logo) {
                    <a [routerLink]="'/'">
                      <img [src]="getImage(logo)" [alt]="logo.altText || 'UK Site Logo'" [ngClass]="logo.altText === 'flu360 color logo' ? 'flu360_Logo' : 'seqirus_Logo'">
                    </a>
                  }
                }
                </div>
              }
              <div class="col-md-8 uk_right_Header_Section">
                <nav class="container container-bottom-header"
                  [ngClass]="currentSite==='seqirusb2b-uk' && publicpage ? 'publicpageenable' : ''">
                  <div class="row headerSection">
                    <div class="col-md-12 col-lg-12 navcolumn">
                      <nav class="primary-nav" [ngClass]="currentSite === 'seqirusb2b-uk' ? 'Primary-navUk' : ''">
                        @for (node of ukNavigation2; track node) {
                          <ul>
                            <li
                                [ngClass]="{
                                  'toploginheader':node.title === 'Log in',
                                  'redcreateprofile': node.title === 'Create flu360 Profile',
                                  'nav-item dropdown has-megamenu': node.title !== 'Create flu360 Profile',
                                  'notactive': node.title === 'Create flu360 Profile' && isUserLoggedIn && !userInfo?.webEnabled && newuserData
                                }"
                              >
                              <!-- ======================================================= -->
                              <!-- LOGGED OUT → SHOW CREATE ACCOUNT (same as US)          -->
                              <!-- ======================================================= -->
                              @if (!isUserLoggedIn) {
                                <a
                                  [ngClass]="node.title === 'Create flu360 Profile' ? 'CreateProfile logoutversion' : 'nav-link dropdown-toggle under_arrow logoutversion'"
                                  [attr.data-bs-toggle]="node.children ? 'dropdown' : null"
                                  [routerLink]="node.children ? '' : node.url=='/login'?'/homepage':node.url"
                                  >
                                  <span [innerHTML]="node.title"></span>
                                  @if (node.children) {
                                    <i class="glyphicon glyphicon-menu-down"></i>
                                  }
                                  @if(node.title=='Create flu360 Profile'){
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                      <mask id="mask0_11308_9310" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                        <rect width="24" height="24" fill="#D9D9D9"/>
                                      </mask>
                                      <g mask="url(#mask0_11308_9310)">
                                        <path d="M5.85 17.1C6.7 16.45 7.65 15.9375 8.7 15.5625C9.75 15.1875 10.85 15 12 15C13.15 15 14.25 15.1875 15.3 15.5625C16.35 15.9375 17.3 16.45 18.15 17.1C18.7333 16.4167 19.1875 15.6417 19.5125 14.775C19.8375 13.9083 20 12.9833 20 12C20 9.78333 19.2208 7.89583 17.6625 6.3375C16.1042 4.77917 14.2167 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 12.9833 4.1625 13.9083 4.4875 14.775C4.8125 15.6417 5.26667 16.4167 5.85 17.1ZM12 13C11.0167 13 10.1875 12.6625 9.5125 11.9875C8.8375 11.3125 8.5 10.4833 8.5 9.5C8.5 8.51667 8.8375 7.6875 9.5125 7.0125C10.1875 6.3375 11.0167 6 12 6C12.9833 6 13.8125 6.3375 14.4875 7.0125C15.1625 7.6875 15.5 8.51667 15.5 9.5C15.5 10.4833 15.1625 11.3125 14.4875 11.9875C13.8125 12.6625 12.9833 13 12 13ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C12.8833 20 13.7167 19.8708 14.5 19.6125C15.2833 19.3542 16 18.9833 16.65 18.5C16 18.0167 15.2833 17.6458 14.5 17.3875C13.7167 17.1292 12.8833 17 12 17C11.1167 17 10.2833 17.1292 9.5 17.3875C8.71667 17.6458 8 18.0167 7.35 18.5C8 18.9833 8.71667 19.3542 9.5 19.6125C10.2833 19.8708 11.1167 20 12 20ZM12 11C12.4333 11 12.7917 10.8583 13.075 10.575C13.3583 10.2917 13.5 9.93333 13.5 9.5C13.5 9.06667 13.3583 8.70833 13.075 8.425C12.7917 8.14167 12.4333 8 12 8C11.5667 8 11.2083 8.14167 10.925 8.425C10.6417 8.70833 10.5 9.06667 10.5 9.5C10.5 9.93333 10.6417 10.2917 10.925 10.575C11.2083 10.8583 11.5667 11 12 11Z" fill="#EA181B"/>
                                      </g>
                                    </svg>
                                  }
                                  @if(node.title=='Log in'){
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                      <path d="M13 21C12.7167 21 12.4793 20.904 12.288 20.712C12.0967 20.52 12.0007 20.2827 12 20C11.9993 19.7173 12.0953 19.48 12.288 19.288C12.4807 19.096 12.718 19 13 19H19V5H13C12.7167 5 12.4793 4.904 12.288 4.712C12.0967 4.52 12.0007 4.28267 12 4C11.9993 3.71733 12.0953 3.48 12.288 3.288C12.4807 3.096 12.718 3 13 3H19C19.55 3 20.021 3.196 20.413 3.588C20.805 3.98 21.0007 4.45067 21 5V19C21 19.55 20.8043 20.021 20.413 20.413C20.0217 20.805 19.5507 21.0007 19 21H13ZM11.175 13H4C3.71667 13 3.47934 12.904 3.288 12.712C3.09667 12.52 3.00067 12.2827 3 12C2.99934 11.7173 3.09534 11.48 3.288 11.288C3.48067 11.096 3.718 11 4 11H11.175L9.3 9.125C9.11667 8.94167 9.025 8.71667 9.025 8.45C9.025 8.18333 9.11667 7.95 9.3 7.75C9.48334 7.55 9.71667 7.44567 10 7.437C10.2833 7.42833 10.525 7.52433 10.725 7.725L14.3 11.3C14.5 11.5 14.6 11.7333 14.6 12C14.6 12.2667 14.5 12.5 14.3 12.7L10.725 16.275C10.525 16.475 10.2877 16.571 10.013 16.563C9.73834 16.555 9.50067 16.4507 9.3 16.25C9.11667 16.05 9.02934 15.8127 9.038 15.538C9.04667 15.2633 9.14234 15.034 9.325 14.85L11.175 13Z" fill="#EA181B"/>
                                    </svg>
                                  }
                              
                                </a>
                              }
                              <!-- ======================================================= -->
                              <!-- LOGGED IN + NON-WEB-ENABLED CASES                      -->
                              <!-- ======================================================= -->
                              @if (isUserLoggedIn && !userInfo?.webEnabled) {
                                <!-- ================================ -->
                                <!-- Case 2: newuserData = false      -->
                                <!-- → SHOW COMPLETE MY PROFILE      -->
                                <!-- ================================ -->
                                @if (!newuserData) {
                                  <a class="loginversion"
                                    [ngClass]=
                                    "{ 
                                    'CreateProfile':node.title === 'Create flu360 Profile',
                                    'nav-link dropdown-toggle under_arrow':node.title !== 'Create flu360 Profile'
                                }"
                                    [attr.data-bs-toggle]="node.children ? 'dropdown' : null"
                                    (click)="handleLinks(node.children ? '' : (node.title === 'Create flu360 Profile' ? '/register' : node.url), '')"
                                    >
                                    <span [innerHTML]="node.title === 'Create flu360 Profile' ? 'Complete Your Profile' : node.title"></span>
                                    @if (node.children) {
                                      <i class="glyphicon glyphicon-menu-down"></i>
                                    }
                                    @if(node.title=='Create flu360 Profile'){
                                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <mask id="mask0_11308_9310" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                          <rect width="24" height="24" fill="#D9D9D9"/>
                                        </mask>
                                        <g mask="url(#mask0_11308_9310)">
                                          <path d="M5.85 17.1C6.7 16.45 7.65 15.9375 8.7 15.5625C9.75 15.1875 10.85 15 12 15C13.15 15 14.25 15.1875 15.3 15.5625C16.35 15.9375 17.3 16.45 18.15 17.1C18.7333 16.4167 19.1875 15.6417 19.5125 14.775C19.8375 13.9083 20 12.9833 20 12C20 9.78333 19.2208 7.89583 17.6625 6.3375C16.1042 4.77917 14.2167 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 12.9833 4.1625 13.9083 4.4875 14.775C4.8125 15.6417 5.26667 16.4167 5.85 17.1ZM12 13C11.0167 13 10.1875 12.6625 9.5125 11.9875C8.8375 11.3125 8.5 10.4833 8.5 9.5C8.5 8.51667 8.8375 7.6875 9.5125 7.0125C10.1875 6.3375 11.0167 6 12 6C12.9833 6 13.8125 6.3375 14.4875 7.0125C15.1625 7.6875 15.5 8.51667 15.5 9.5C15.5 10.4833 15.1625 11.3125 14.4875 11.9875C13.8125 12.6625 12.9833 13 12 13ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C12.8833 20 13.7167 19.8708 14.5 19.6125C15.2833 19.3542 16 18.9833 16.65 18.5C16 18.0167 15.2833 17.6458 14.5 17.3875C13.7167 17.1292 12.8833 17 12 17C11.1167 17 10.2833 17.1292 9.5 17.3875C8.71667 17.6458 8 18.0167 7.35 18.5C8 18.9833 8.71667 19.3542 9.5 19.6125C10.2833 19.8708 11.1167 20 12 20ZM12 11C12.4333 11 12.7917 10.8583 13.075 10.575C13.3583 10.2917 13.5 9.93333 13.5 9.5C13.5 9.06667 13.3583 8.70833 13.075 8.425C12.7917 8.14167 12.4333 8 12 8C11.5667 8 11.2083 8.14167 10.925 8.425C10.6417 8.70833 10.5 9.06667 10.5 9.5C10.5 9.93333 10.6417 10.2917 10.925 10.575C11.2083 10.8583 11.5667 11 12 11Z" fill="#EA181B"/>
                                        </g>
                                      </svg>
                                    }
                                   
                                  </a>
                                }
                                <!-- ================================ -->
                                <!-- Case 3: newuserData = true       -->
                                <!-- → SHOW NOTHING                  -->
                                <!-- ================================ -->
                                @if (newuserData) {
                                  <!-- Hidden intentionally -->
                                }
                              }
                              <!-- ======================================================= -->
                              <!-- LOGGED IN + WEB-ENABLED → HIDE CREATE ACCOUNT           -->
                              <!-- (No block needed; nothing renders)                      -->
                              <!-- ======================================================= -->
                            </li>
                          </ul>
                        }
                      </nav>
                    </div>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }
  <!---Logged out header US-->
  @if ((node$ | async); as navNode) {
    <div>
      @if (navNode.title == 'For US Healthcare Professionals Only') {
        <div class="header d-none d-sm-none d-md-block d-lg-block">
          <div class="container container-top-header us_LO_Container_TopHeader">
            <div class="row top_Row_Header">
              <div class="col-sm-4 leftsectionheader">
                @for (node of navigation; track node) {
                  @if (node.title == 'For US Healthcare Professionals Only') {
                    <div class="for-healthcare-profe healthcare-US">
                      <div class="button" style="cursor: pointer;" (click)="openList()" [ngClass]="toggleListView?'open':''">
                        <img src="assets/images/AmericanFlag_Icon.png">
                        <span>{{node.title}}<span class="glyphicon glyphicon-menu-down"></span></span>
                        <ul class="select-list">
                          <li class="clsAnchor" [style.display]="toggleListView?'':'none'">
                            <a href="{{node.children[0].url}}">
                              <img src="assets/images/GBFlag_Icon.png"> {{node.children[0].title}}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  }
                }
              </div>
              <div class="col-sm-8 rightsectionheader">
                <div class="header-nav">
                  @for (nav of filteredNavigation; track nav) {
                    <ul class="login-links marginBottom">
                      <li class="dropdown" [ngClass]="nav.title === 'About' || nav.title === 'Support' ? 'headerpadding' : ''">
                        <!-- Other Navigation Items -->
                        @if (nav.uid !== 'LoginNavNode') {
                          <a [routerLink]="(isUserLoggedIn && !userInfo?.webEnabled && nav.title === 'Log In') ? '/logout' : nav.url" class="dropdown-toggle droppreb" (click)="reloadAfterLogout()" id="drop1" data-bs-toggle="dropdown" aria-expanded="true" role="button">{{ (isUserLoggedIn && !userInfo?.webEnabled && nav.title === 'Log In') ? 'Log Out' : nav.title }}@if (nav.children) {
                            <span class="glyphicon glyphicon-menu-down" style="top: 3px; left: 3px"></span>
                          }
                          @if (nav.title === 'Log In') {
                            <span style="margin-left: 5px; color: #2A3237 !important;">
                              <img alt="{{ isUserLoggedIn && !userInfo?.webEnabled ? 'Log out icon' : 'Log in icon' }}" style="width: 28px;" [src]="isUserLoggedIn && !userInfo?.webEnabled ? '/assets/images/login_icon.png' : '/assets/images/login_icon.png'"/>
                            </span>
                          }
                        </a>
                        <!-- Dropdown Menu -->
                        @if (nav.uid !== 'PrescribingNavNode' && nav.children) {
                          <ul class="dropdown-menu header_dropdwn" aria-labelledby="drop1">
                            <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: nav.children }"></ng-container>
                          </ul>
                        } @else {
                          <ul class="dropdown-menu header_dropdwn" aria-labelledby="drop1">
                            @for (child of nav.children; track child) {
                              <li class="dropdown_first_level">
                                <a [href]="child.url" target="_blank" rel="noopener noreferrer" class="nav-link" [innerHTML]="child.title"></a>
                              </li>
                            }
                          </ul>
                        }
                        <!-- Prescribing Info Special Case -->
                      }
                    </li>
                  </ul>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="container container-top-header">
          <div class="row bottom_Row_Header">
            @if (usSiteLogos$ | async; as usLogos) {
              <div class="col-md-4 site_Logo_Img">
                @for (logo of usLogos; track logo) {
                  <a [routerLink]="'/'"  [ngClass]="logo.altText === 'flu360 color logo' ? 'is_flu360_Logo' : 'is_seqirus_Logo'">
                    <img [src]="getImage(logo)" [alt]="logo.altText || 'UK Site Logo'" [ngClass]="logo.altText === 'flu360 color logo' ? 'flu360_Logo' : 'seqirus_Logo'">
                  </a>
                }
              </div>
            }
            <div class="header BottomHeaderSlot has-components">
              <div class="col-md-12 col-lg-12 navcolumn">
                <nav class="primary-nav" [ngClass]="currentSite === 'seqirusb2b-uk' ? 'Primary-navUk' : ''">
                  @for (node of remainingNavigation; track node) {
                    <ul>
                      <!-- ========================= -->
                      <!-- SPECIAL CASE: Create Account / Complete My Profile -->
                      <!-- ========================= -->
                      @if (node.title === 'Create Account') {
                        <!--
                        Show only in these cases:
                        - Logged OUT => Create Account (Rule 1)
                        - Logged IN + non-web-enabled + !newuserData => Complete My Profile (Rule 2)
                        Hide otherwise (Rules 3 & 4)
                        -->
                        @if (!isUserLoggedIn || (isUserLoggedIn && !userInfo?.webEnabled && !newuserData)) {
                            <li [ngClass]="{
                                  'redborder': true,
                                  'nav-item dropdown has-megamenu': true
                                }">
                            <!-- LOGGED OUT: Create Account -->
                            @if (!isUserLoggedIn) {
                              <a
                                class="create-account"
                                [attr.data-bs-toggle]="node.children ? 'dropdown' : null"
                                [routerLink]="node.children ? null : node.url"
                                (click)="reloadOnlyIfAlreadyOnCreateProfile(node, $event)"
                                >
                                <span [innerHTML]="'Create Account'"></span>
                                @if (node.children) {
                                  <i class="glyphicon glyphicon-menu-down"></i>
                                }
                              </a>
                            }
                            <!-- LOGGED IN + NON-WEB-ENABLED + NOT REGISTERED: Complete My Profile -->
                            @if (isUserLoggedIn && !userInfo?.webEnabled && !newuserData) {
                              <a
                                class="create-account"
                                [attr.data-bs-toggle]="node.children ? 'dropdown' : null"
                                (click)="handleLinks(node.children ? '' : '/register', '')"
                                >
                                <span [innerHTML]="'Complete My Profile'"></span>
                                @if (node.children) {
                                  <i class="glyphicon glyphicon-menu-down"></i>
                                }
                              </a>
                            }
                            <!-- Dropdown Indicator Arrow -->
                            @if (node.children) {
                              <div class="indicator_arrow">
                                <i class="fa fa-angle-up" aria-hidden="true"></i>
                              </div>
                            }
                            <!-- Dropdown Menu -->
                            <ul class="dropdown-menu megamenu pro_menu">
                              <ng-container *ngTemplateOutlet="recursiveNavBarList; context: { $implicit: node.children }"></ng-container>
                            </ul>
                          </li>
                        }
                        <!-- If logged in & webEnabled OR logged in & non-web-enabled & newuserData=true => this node is hidden -->
                      }
                      <!-- ========================= -->
                      <!-- DEFAULT CASE: All other nodes -->
                      <!-- Keep your site filter logic here -->
                      <!-- ========================= -->
                      @if (node.title !== 'Create Account') {
                        @if ((currentSite === 'seqirusb2b-uk' && isUserLoggedIn && !userInfo?.webEnabled)
                          || !isUserLoggedIn
                          || currentSite === 'seqirusb2b-flu360') {
                            <li [ngClass]="{
                                  'nav-item dropdown has-megamenu': true
                                }">
                            <!-- Logged Out (non-Create Account) -->
                            @if (!isUserLoggedIn) {
                              <a
                                class="nav-link dropdown-toggle under_arrow"
                                [attr.data-bs-toggle]="node.children ? 'dropdown' : null"
                                [routerLink]="node.children ? null : node.url"
                                (click)="reloadOnlyIfAlreadyOnCreateProfile(node, $event)"
                                >
                                <span [innerHTML]="node.title"></span>
                                @if (node.children) {
                                  <i class="glyphicon glyphicon-menu-down"></i>
                                }
                              </a>
                            }
                            <!-- Logged In, Non-Web Enabled (non-Create Account) -->
                            @if (isUserLoggedIn && !userInfo?.webEnabled) {
                              <a
                                class="nav-link dropdown-toggle under_arrow"
                                [attr.data-bs-toggle]="node.children ? 'dropdown' : null"
                                (click)="handleLinks(node.children ? null : node.url, '')"
                                >
                                <span [innerHTML]="node.title"></span>
                                @if (node.children) {
                                  <i class="glyphicon glyphicon-menu-down"></i>
                                }
                              </a>
                            }
                            <!-- Dropdown Indicator Arrow -->
                            @if (node.children) {
                              <div class="indicator_arrow">
                                <i class="fa fa-angle-up" aria-hidden="true"></i>
                              </div>
                            }
                            <!-- Dropdown Menu -->
                            <ul class="dropdown-menu megamenu pro_menu">
                              <ng-container *ngTemplateOutlet="recursiveNavBarList; context: { $implicit: node.children }"></ng-container>
                            </ul>
                          </li>
                        }
                      }
                    </ul>
                  }
                </nav>
              </div>
            </div>
            <!-- Recursive Template -->
            <ng-template #recursiveNavBarList let-children>
              @for (child of children; track child) {
                <li class="dropdown_first_level">
                  <a [routerLink]="child.url" class="nav-link" [innerHTML]="child.title"></a>
                  @if (child.children?.length) {
                    <ul class="second_level_menu">
                      <ng-container *ngTemplateOutlet="recursiveNavBarList; context: { $implicit: child.children }"></ng-container>
                    </ul>
                  }
                </li>
              }
            </ng-template>
          </div>
        </div>
      </div>
    }
  </div>
}
<ng-template #recursiveList let-children>
  @for (child of children; track child) {
    <li>
      <a [routerLink]="child.url" title="{{child.title}}" target="_blank" [innerHTML]="child.title"></a>
      @if (child.children) {
        <ul>
          <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: child.children }"></ng-container>
        </ul>
      }
    </li>
  }
</ng-template>
<!-- mobile header -->
@if ((node$ | async); as navNode) {
  <div>
    <!-- for site node -->
    @if (navNode.title == 'For US Healthcare Professionals Only') {
      <div class="header d-md-none d-lg-none d-block d-sm-block">
        @for (node of navNode.children; track node) {
          <div class="for-healthcare-profe-mob col-xs-12 col-sm-12">
            @for (child of node.children; track child) {
              <div class="healthcare-US" >
                @if (child.title == 'For US Healthcare Professionals Only') {
                  <div>
                    <div class="button" (click)="openList()">
                      <img src="assets/images/AmericanFlag_Icon.png"> <span>{{child.title}}</span><span class="glyphicon glyphicon-menu-down"></span>
                    </div>
                    <ul class="select-list">
                      <li class="clsAnchor" [style.display]="toggleListView?'':'none'">
                        <a [href]="child.children[0].url"><img src="assets/images/GBFlag_Icon.png"><span class="">{{child.children[0].title}}</span></a>
                      </li>
                    </ul>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }
    <div class="d-md-none d-lg-none d-block d-sm-block">
      <div class="mob-logo-wrap">
        <!-- for logos -->
        @if (usSiteLogos$ | async; as usLogos) {
          <div class="col-xs-6 col-sm-3 moblogo_container">
            @for (logo of usLogos; track logo) {
              <a [routerLink]="'/'" [ngClass]="logo.altText === 'flu360 color logo' ? 'is_flu360_Logo' : 'is_seqirus_Logo'">
                <img [src]="getImage(logo)" [alt]="logo.altText || 'UK Site Logo'" [ngClass]="logo.altText === 'flu360 color logo' ? 'flu360_Logo' : 'seqirus_Logo'" />
              </a>
            }
          </div>
        }
        <div class="col-xs-6 col-sm-9 mob-menu">
          <i class="fa" [ngClass]="iconClass" (click)="toggleSlide()"></i>
        </div>
      </div>
      <div class="mob_exp_menu">
        <!-- Accordion Menu START -->
        <div class="panel-group" id="accordion">
          @for (node of remainingNavigation; track node; let i = $index) {
            <div class="panel panel-default">
              @if (node.children) {
                <div class="panel-heading accordion-toggle collapsed" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse' + i" style="cursor:pointer;">
                  <h4 class="panel-title" [innerHTML]="node.title">{{node.title}}</h4>
                </div>
              }
              @if (node.title == 'Tools & Resources') {
                <div class="panel-heading">
                  <h4 class="panel-title"><a [routerLink]="node.url" [innerHTML]="node.title">{{node.title}}</a></h4>
                </div>
              }
              <div [id]="'collapse' + i" class="panel-collapse collapse">
                <div class="panel-body">
                  <ul class="mob_sub_menu">
                    @for (child of node.children; track child) {
                      <div>
                        <li>
                          <a [routerLink]="child.url" target="_self" title="{{child.title}}" [innerHTML]="child.title">
                            {{child.title}}
                          </a>
                          <ul class="second_level_mob_sub">
                            @for (grandchild of child.children; track grandchild) {
                              <div>
                                <li>
                                  <a [routerLink]="grandchild.url" target="_self" title="{{grandchild.title}}">
                                    {{grandchild.title}}
                                  </a>
                                </li>
                              </div>
                            }
                          </ul>
                        </li>
                      </div>
                    }
                  </ul>
                </div>
              </div>
            </div>
          }
          @for (node of filteredNavigation; track node; let i = $index) {
            @if (node.title === 'Prescribing Information' || node.title === 'Important Safety Information') {
              <div class="panel panel-default">
                <div class="panel-heading accordion-toggle collapsed" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse1' + i" style="cursor:pointer;">
                  <h4  class="panel-title-default">
                    {{node.title}}
                  </h4>
                </div>
                <div [id]="'collapse1' + i" class="panel-collapse collapse">
                  <div class="panel-body">
                    <ul class="mob_sub_menu">
                      @if (node.title == 'Prescribing Information' || node.title == 'Important Safety Information') {
                        <ul class="second_level_mob_sub">
                          @for (child of node.children; track child) {
                            <div>
                              @if (node.title == 'Prescribing Information') {
                                <li>
                                  <a [href]="child.url" target="_blank" title="{{child.title}}" [innerHTML]="child.title"></a>
                                </li>
                              }
                              @if (node.title == 'Important Safety Information') {
                                <li>
                                  <a [routerLink]="child.url" target="_self" title="{{child.title}}" [innerHTML]="child.title"></a>
                                </li>
                              }
                            </div>
                          }
                        </ul>
                      }
                      <ng-template #othernode>
                        @for (child of node.children; track child) {
                          <div>
                            <li>
                              <a [routerLink]="child.url" target="_self" title="{{child.title}}" [innerHTML]="child.title">
                                {{child.title}}
                              </a>
                              <ul class="second_level_mob_sub">
                                @for (grandchild of child.children; track grandchild) {
                                  <div>
                                    <li>
                                      <a [routerLink]="grandchild.url" target="_self" title="{{grandchild.title}}">
                                        {{grandchild.title}}
                                      </a>
                                    </li>
                                  </div>
                                }
                              </ul>
                            </li>
                          </div>
                        }
                      </ng-template>
                    </ul>
                  </div>
                </div>
              </div>
            }
            @if (node.title == 'About') {
              <div class="panel-heading">
                <h4 class="panel-title-default">
                  <a [routerLink]="node.url" target="_self" title="{{node.title}}">{{node.title}}</a>
                </h4>
              </div>
            }
            @if (node.title == 'Support') {
              <div class="panel-heading">
                <h4 class="panel-title-default">
                  <a [routerLink]="node.url" target="_self" title="{{node.title}}">{{node.title}}</a>
                </h4>
              </div>
            }
          }
        </div>
        <!-- Accordion menu END -->
        <div class="default-mob-menu-item">
          @for (parnode of navNode.children; track parnode) {
            <div>
              @for (node of parnode.children; track node) {
                <div>
                  @if (node.title === 'Create Account') {
                    <div class="col-xs-6">
                      <div class="redborder">
                        @if (!isUserLoggedIn) {
                          <a class="create-account" [routerLink]="node.url">{{node.title}}</a>
                        }
                        @if (isUserLoggedIn && (!userInfo?.webEnabled) && !newuserData) {
                          <a class="create-account" routerLink="/register">
                            <span>Complete My Profile</span>
                          </a>
                        }
                      </div>
                    </div>
                  }
                  @if (node.title === 'Log In' && node.value== 2) {
                    <div class="col-xs-6 mob-login-icon">
                      @if (!isUserLoggedIn) {
                        <a class="log-in" [routerLink]="node.url">
                          {{node.title}}
                          <span style="top: 3px;">
                            <img alt="Log in icon" src="assets/images/login_icon.png" />
                          </span>
                        </a>
                      }
                      @if (isUserLoggedIn && (!userInfo?.webEnabled)) {
                        <a class="log-in" routerLink="/logout">
                          Log Out
                          <span style="top: 3px;">
                            <img alt="Log in icon" src="assets/images/login_icon.png" />
                          </span>
                        </a>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
}



<!--loggedin header US-->
@if (isUserLoggedIn && userInfo?.webEnabled && currentSite === 'seqirusb2b-flu360') {
  <div class="d-none d-sm-none d-md-block d-lg-block">
    <header class="hidden-xs hidden-sm visible-md-* visible-lg-* loggedin_HeaderBar">
      <nav class="container-fluid loggedIn customlog">
        <div class="row">
          @if (usSiteLogos$ | async; as usLogos) {
            <div class="col-md-4 us_Li_SiteLogo">
              @for (logo of usLogos; track logo) {
                <a [routerLink]="'/'" [ngClass]="logo.altText === 'flu360 color logo' ? 'is_flu360_Logo' : 'is_seqirus_Logo'">
                  <img [src]="getImage(logo)" [alt]="logo.altText || 'UK Site Logo'" [ngClass]="logo.altText === 'flu360 color logo' ? 'flu360_Logo' : 'seqirus_Logo'">
                </a>
              }
            </div>
          }
          <div class="col-md-8 headerSection loggedIn_Header_RightSection">
            <div class="col-lg-4 col-md-1 dashboard_search"></div>
            <div class="container_outside container_outside">
              <!-- account dropdown changes -->
              <div class="col-lg-1 col-md-3 dashboard_cart">
                <!-- cart icon changes-->
                <a class="savedbox" (click)="handleLinks('/start-order', '')" style="text-decoration: none !IMPORTANT">
                  <img src="/assets/images/head_cart.png" width="27" alt="cart">@if (isCartExist | async; as item) {
                  <b>@if (item == 'YES') {
                    <span class="savedcartdot" style="display: inline;"></span>
                  }</b>
                }&nbsp;Cart</a>
              </div>
              <div class="col-lg-2 col-md-3 dashboard_profile">
                @if (userInfo) {
                  <a href="#" class="profilenavlinks" (click)="toggleDropdown($event)" [ngClass]="{'collapsed': !isDropdownOpen}" [attr.aria-expanded]="isDropdownOpen"><img src="/assets/images/head_profile.png" width="25" alt="profile"> {{userInfo?.firstName+' '+ userInfo?.lastName}}<i class="fa fa-fw .fas fa-angle-down"></i></a>
                }
                <ul id="headermyprofile-one" class="header_myprofile-submenu header_MyProfile_LinkUS" [ngClass]="{'show': isDropdownOpen}">
                  @if (userInfo) {
                    <li class="welcomemsg">Good Morning, {{userInfo?.firstName + ' ' + userInfo?.lastName}}</li>
                  }
                  <li (click)="goMyprofile(); closeDropdown()">
                    <a style="cursor: pointer;" class="profilenavlinks myProfile_Link">
                      <img class="headprofile" src="/assets/images/head_profile.png" width="25" alt="profile">My Profile
                    </a>
                  </li>
                  <li>
                    <a (click)="logOutredirect()" class="profilenavlinks">
                      <i class="" style="padding: 5px;"><img src="/assets/images/logout_icon.png"></i>Log Out
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
  </div>
}

<!--loggedin header UK-->
@if (isUserLoggedIn && userInfo?.webEnabled && currentSite === 'seqirusb2b-uk') {
  <div class="d-none d-sm-none d-md-block d-lg-block logged_in_Header_UK_Container">
    <!--  {{toprbafunction()}} -->
    @if (ukSiteLogos$ | async; as ukLogos) {
      <div class="logoUK">
        @for (logo of ukLogos; track logo) {
          <a [routerLink]="'/'">
            <img [src]="getImage(logo)" [alt]="logo.altText || 'UK Site Logo'"
              [ngClass]="logo.altText === 'flu360 color logo' ? 'flu360_Logo' : 'seqirus_Logo'">
            </a>
          }
        </div>
      }
      <header class="headerbar hidden-xs hidden-sm visible-md-* visible-lg-* whiteBguk loggedin_UK_Right_Container">
        <nav class="container-fluid loggedIn customlogUK">
          <div class="row headerSection">
            <div class="dashboard_searchUK"></div>
            <div class="container_outside container_outsideUK"> <!-- account dropdown changes -->
              <div class="dashboard_cartUK">
                <!--  add condition to show place order or not -->
                @if (rbavarible?.RBAPermissions==true && rbavarible?.showDashboardOrderUK==true) {
                  <div class="dashboard_orderUK placebtn">
                    <a (click)="handleLinks('/start-order', '')" style="text-decoration: none !IMPORTANT" >
                      <img
                        src="assets/images/head_cart.png"
                        width="27" alt="placeorder">
                        &nbsp; Place an Order
                      </a>
                    </div>
                  }
                  @if (rbavarible?.RBAPermissions!=true) {
                    <div class="dashboard_orderUK">
                      <a (click)="handleLinks('/start-order', '')" style="text-decoration: none !IMPORTANT" >
                        <img
                          src="assets/images/head_cart.png"
                          width="27" alt="placeorder">
                          &nbsp; Place an Order
                        </a>
                      </div>
                    }
                    @if (showStatus() || (isSearchByProfile && !showStatus())) {
                      <div class="dashboard_accountUK">
                        <a href="#" data-bs-toggle="collapse"  class="profilenavlinks dashboard_accountUK-arrow" (click)="toggleSlideUkAcc()" [ngClass]="{'collapsed':!isCollapsed}">
                          <img [src]="iconUkAcc=='fa-angle-down'?'assets/images/Icon_Cart_Grey_110.png':'assets/images/Icon _Cart_red.png'" width="25" alt="profile"><span id="selectCompanyName">{{userInfo.orgUnit.name}}</span><i class="fa fa-fw " [ngClass]="iconUkAcc=='fa-angle-down'?'fa-angle-down':'fa-angle-up'" ></i></a>
                          <div id="headeraccount-dropdown" class="collapse header_myprofile-submenuUK" [ngClass]="{'show':isCollapsed}">
                            <div class='header_dropdown-topsection'>
                              <div class='header_accountText'>Accounts</div>
                              <a (click)="handleLinks('/register/join-account', '')" class="header_joinaccountText">Link To Another Account</a>
                            </div>
                            @if (multipleSoldTos?.length > 1) {
                              <div class='header_multipleAccount dymanicAccount'> <!-- to be hidden for single account -->
                                <div class="header_multipleAccount-searchbar">
                                  <div class="header_multipleAccount-searchicon">
                                    <i class="fa fa-search"></i>
                                  </div>
                                  <input class="header_multipleAccount-searchfield" id="header_multipleAccount-searchfield" name="lookup" placeholder="Search accounts" type="text" [(ngModel)]="searchText" (input)="filterAccount()">
                                </div>
                                <div class="header_multipleAccount-radiogroup">
                                  @for (acc of filteredMultipleSoldTos; track acc; let i = $index) {
                                    <div class="col-xs-12 multipleaccount-radiocontainer">
                                      <div class="multipleaccount-radio" [ngClass]="selectedAccount === acc.accountNumber ? 'radiobtn-checked':''">
                                        <input type="radio" class="multipleaccount-radiobtn"  id="multipleaccount-radiobtn{{i}}" [checked]="selectedAccount === acc.accountNumber"  (change)="onRadiochange(acc.accountNumber)" [value]="acc.accountNumber"/>
                                        <span class="radio-button__control"></span>
                                        <label for="multipleaccount-radiobtn{{i}}">{{acc.organizationName}}</label>
                                      </div>
                                      <label class="multipleaccount-postcode" for="multipleaccount-radiobtn{{i}}">{{acc.postalCode}}</label>
                                    </div>
                                  }
                                </div>
                                <button class="multipleaccount_switchAccount" [disabled]="selectedAccount === userInfo?.orgUnit.uid" (click)="changeAccount()">Switch Account</button>
                                <div class="clearboth"></div>
                              </div>
                            } @else {
                              <div class='header_singleAccount'>
                                You can have multiple accounts associated with your user profile.
                              </div>
                            }
                          </div>
                        </div>
                      }
                    </div>
                    <div class="col-lg-2 col-md-3 dashboard_profileUK">
                      <div class="col-lg-2 col-md-3 dashboard_profileUK">
                        <a href="#" (click)="toggleDropdown($event)" class="profilenavlinks" [ngClass]="{'collapsed': !isDropdownOpen}" [attr.aria-expanded]="isDropdownOpen">
                          <img src="assets/images/head_profile.png" width="25" alt="profile"> {{userInfo?.firstName + ' ' + userInfo?.lastName}}
                          <i class="fa fa-fw" [ngClass]="isDropdownOpen ? 'fa-angle-up' : 'fa-angle-down'"></i>
                        </a>
                        <ul id="headermyprofile-one" class="header_myprofile-submenuUK" [ngClass]="{'show': isDropdownOpen}">
                          <li>
                            <a (click)="handleLinks('/my-profile', ''); closeDropdown()" class="profilenavlinks">
                              <img class="headprofileuk" src="assets/images/head_profile.png" width="25" alt="profile">My Profile
                            </a>
                          </li>
                          <li>
                            <a (click)="handleLinks('/logout', '')" class="profilenavlinks">
                              <i class="" style="padding: 5px;"><img src="assets/images/logout_icon.png" /></i>Log Out
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </nav>
            </header>
          </div>
        }

        <!--logged in mobile header-->

        @if (isUserLoggedIn && userInfo?.webEnabled) {
          <div class="us_mobileheader d-md-none d-lg-none d-block d-sm-block">
            @if (usSiteLogos$ | async; as usLogos) {
              <div class="col-xs-6 col-sm-3 moblogo_container">
                @for (logo of usLogos; track logo) {
                  <a [routerLink]="'/'">
                    <img [src]="getImage(logo)" [alt]="logo.altText || 'UK Site Logo'" />
                  </a>
                }
              </div>
            }
            <div class="col-xs-6 col-sm-9 mobile_view mob-menu-login">
              <a class="savedbox" (click)="handleLinks('/start-order', '')" style="text-decoration: none !IMPORTANT;">
                <img src="/assets/images/head_cart.png" width="27" alt="cart"> @if (isCartExist | async; as item) {
                <span class="savedcartdotmob" [style.display]="item.toLowerCase() === 'yes' ? 'inline' : 'none'"></span>
              }
            </a>&nbsp;
            <a (click)="handleLinks('/my-profile', '')" class="profilenavlinks">
              <img src="/assets/images/head_profile.png" width="25" alt="profile">
            </a>
            <a class=" profilenavlinks">
              <i class="fa"  [ngClass]="iconClassMob=='fa-solid fa-xmark'?'fa-solid fa-xmark mob_nav_click':'fa fa-bars'" (click)="toggleSlideLoggedInMob()" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      }
